import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sasya_staff_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// Public
export const submitLead = (data) => axios.post(`${API}/leads`, data);
export const submitBooking = (data) => axios.post(`${API}/service-bookings`, data);

// Staff
export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password });
export const fetchLeads = () => axios.get(`${API}/leads`, authHeader());
export const fetchBookings = () => axios.get(`${API}/service-bookings`, authHeader());
export const sendDailySummary = () => axios.post(`${API}/admin/send-daily-summary`, {}, authHeader());

// Pricing
export const fetchPrices = () => axios.get(`${API}/vehicles/prices`);
export const updatePrice = (name, price) => axios.put(`${API}/admin/prices`, { name, price }, authHeader());

// Offers
export const fetchOffers = () => axios.get(`${API}/offers`);
export const fetchAllOffers = () => axios.get(`${API}/admin/offers`, authHeader());
export const createOffer = (data) => axios.post(`${API}/admin/offers`, data, authHeader());
export const patchOffer = (id, data) => axios.patch(`${API}/admin/offers/${id}`, data, authHeader());
export const deleteOffer = (id) => axios.delete(`${API}/admin/offers/${id}`, authHeader());
